import { checkoutUserErrorFragment } from './fragmentGeneral.gql';

const accountLogin = () => (
	`mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
		customerAccessTokenCreate(input: $input) {
			customerAccessToken {
				accessToken
      	expiresAt
			}
			customerUserErrors ${checkoutUserErrorFragment}
		}
	}`
);

export default accountLogin;
